import React from "react";
import SurveyStatIconWrapper from "./SurveyStatIconWrapper";

const iconStroke = "#00C49A";
const iconStrokeWidth = "1.35";

const SurveyOpenSurveysIcon = () => (
    <SurveyStatIconWrapper>
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_16618_32803)">
                <path d="M10.306 1.4541H6.24349C5.86955 1.4541 5.56641 1.75724 5.56641 2.13118V3.48535C5.56641 3.85929 5.86955 4.16243 6.24349 4.16243H10.306C10.6799 4.16243 10.9831 3.85929 10.9831 3.48535V2.13118C10.9831 1.75724 10.6799 1.4541 10.306 1.4541Z" stroke={iconStroke} strokeWidth={iconStrokeWidth} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10.9824 2.80835H12.3366C12.6957 2.80835 13.0402 2.95102 13.2941 3.20498C13.5481 3.45893 13.6908 3.80337 13.6908 4.16252V13.6417C13.6908 14.0008 13.5481 14.3453 13.2941 14.5992C13.0402 14.8532 12.6957 14.9958 12.3366 14.9958H4.21159C3.85244 14.9958 3.508 14.8532 3.25405 14.5992C3.00009 14.3453 2.85742 14.0008 2.85742 13.6417V4.16252C2.85742 3.80337 3.00009 3.45893 3.25405 3.20498C3.508 2.95102 3.85244 2.80835 4.21159 2.80835H5.56576" stroke={iconStroke} strokeWidth={iconStrokeWidth} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.24316 9.57914L7.59733 10.9333L10.3057 8.22498" stroke={iconStroke} strokeWidth={iconStrokeWidth} strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_16618_32803">
                    <rect width="16.25" height="16.25" fill="white" transform="translate(0.149414 0.0999756)" />
                </clipPath>
            </defs>
        </svg>
    </SurveyStatIconWrapper>
);

export default SurveyOpenSurveysIcon;
